import { Button, Card, Checkbox, DatePicker, Form, Icon, InputNumber, Mentions, message, Select, Spin, Tooltip, Upload } from 'antd';
import React, { useState, useEffect } from 'react';
import { getFormFieldByType, sanitizeFieldName } from '../../util/methods';
import SubList from '../../components/SubList';
import AssetSearch from '../../components/AssetSearch';
import moment from 'moment';
import MasterModal from '../../components/MasterModal';

function Create(props) {
  const [asset, setAsset] = useState(null);
  const [lastReading, setLastReading] = useState(null);
  const [meters, setMeters] = useState([]);
  const [documents, setDocuments] = useState([]);

  const { match, fetch, form, data, loading, filters, title, resource, assetData,
    assetSearchLoading, onSubmit, authUser, lastReading: propLastReading, assetMeters, getLastReading, searchGlobalAssetData, getAssetMeterDetail } = props;
  const { getFieldDecorator, validateFields } = form;

  useEffect(() => {
    if (match && match.params && match.params.id) {
      fetch(match.params.id);
    }
  }, [fetch]);

  useEffect(() => {
    if (data && data.asset) {
      setAsset((data.asset && data.asset._id) ? data.asset._id : data.asset);
      if (getAssetMeterDetail) {
        getAssetMeterDetail((data.asset && data.asset._id) ? data.asset._id : data.asset);
      }
    }
  }, [data]);

  useEffect(() => {
    if (propLastReading) {
      setLastReading(propLastReading);
    }
  }, [propLastReading]);

  useEffect(() => {
    // console.log(`assetMeters - ${assetMeters}`);
    if (assetMeters) {
      setMeters(assetMeters);
    }
  }, [assetMeters]);

  const handleSubmit = e => {
    e.preventDefault();
    validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const data = { ...values };
      if (asset) {
        const payload = { ...data, asset, reading: Number(data.reading) || 0, documents };
        if (match.params && match.params.id) {
          onSubmit(payload, match.params.id);
        } else {
          onSubmit(payload);
        }
      } else {
        message.error('Asset is required');
      }
    });
  };

  const handleAssetSelect = value => {
    setAsset(value);
    if (getAssetMeterDetail) {
      getAssetMeterDetail(value);
    }
  };

  return (
    <Spin spinning={loading}>
      <Card className='gx-card-metrics' title={`${title} ${sanitizeFieldName(resource)}`}>
        <div style={{ color: 'red', fontSize: '15px' }}>{lastReading && `Last Reading was : ${lastReading.reading}`}</div>
        <Form onSubmit={handleSubmit} layout='vertical'>
          {Object.keys(filters).map(item => {
            if (filters[item].type === 'Array' && filters[item].schema && item !== 'documents') {
              return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource} />;
            } else {
              if ((item === 'readingNo' || item === 'meterType' || item === 'createdBy') && title === 'CREATE') {
                return null;
              }
              if (item === 'documents') {
                if (title !== 'CREATE') {
                  return null;
                }
                return (
                  <Form.Item key={'documents'} label={'Documents'} style={{ width: '100%' }}>
                    <Upload
                      multiple
                      fileList={documents}
                      beforeUpload={file => {
                        setDocuments(prev => [...prev, file]);
                        return false;
                      }}
                      onRemove={file => {
                        setDocuments(prev => prev.filter(f => f.uid !== file.uid));
                      }}
                    >
                      <Button>
                        <Icon type='upload' /> Select Files
                      </Button>
                    </Upload>
                  </Form.Item>
                );
              }
              if (item === 'source') {
                return (
                  <Form.Item key={'source'} label={'Source'} style={{ width: '100%' }}>
                    {getFieldDecorator('source', {
                      rules: [{ required: true, message: 'Source is required!' }],
                      initialValue: 'MANUAL'
                    })(
                      <Select style={{ width: '100%' }} disabled>
                        <Select.Option value='MANUAL'>MANUAL</Select.Option>
                      </Select>
                    )}
                  </Form.Item>
                );
              }
              if (item === 'isFaultyMeter') {
                return (
                  <Form.Item key={'isFaultyMeter'} label={'Is Faulty Meter'}>
                    {getFieldDecorator('isFaultyMeter', {
                      valuePropName: 'checked',
                      initialValue: false
                    })(
                      <Checkbox disabled />
                    )}
                  </Form.Item>
                );
              }
              if (item === 'asset') {
                return (
                  <Form.Item key={'asset'} label={'Enter Asset'} style={{ width: '100%' }}>
                    {getFieldDecorator('asset', {
                      rules: [{ required: true, message: 'Asset is required!' }],
                      initialValue: data && data.asset || asset
                    })(
                      <AssetSearch
                        styleName='gx-lt-icon-search-bar-lg'
                        onChange={searchGlobalAssetData}
                        onSelect={handleAssetSelect}
                        assetData={assetData && assetData.filter(ast => ast.assetModel)} // only assets with assetModel
                        authUser={authUser}
                        loading={assetSearchLoading}
                        defaultAsset={data && data.asset}
                      />
                    )}
                  </Form.Item>
                );
              }
              if (item === 'meter') {
                return (
                  <Form.Item key={'meter'} label={'Meter'} style={{ width: '100%' }}>
                    {getFieldDecorator('meter', {
                      rules: [{ required: true, message: 'Meter is required!' }],
                      initialValue: data && data.meter && data.meter._id
                    })(
                      <Select
                        onSelect={v => getLastReading(v)}
                        allowClear
                        style={{ width: '100%' }}
                        placeholder='Please select Meter'
                        disabled={title === 'EDIT' || !meters.length}
                      >
                        {meters.map(item => <Select.Option key={item._id} value={item._id}>{`${item.meterNo} - (${item.meterType && item.meterType.name})`}</Select.Option>)}
                      </Select>
                    )}
                    {/* {
                      filters && filters['meter'] && filters['meter'].options && filters['meter'].options.master ?
                        <MasterModal resource={resource} item={filters['meter'].options.ref}
                          title={'CREATE'} /> : ''
                    } */}
                  </Form.Item>
                );
              }
              if (item === 'readingDate') {
                return (
                  <Form.Item key={'readingDate'} label={'Reading Time'} style={{ width: '100%' }}>
                    {getFieldDecorator('readingDate', {
                      rules: [{ required: true, message: 'Reading Time is required!' }],
                      initialValue: data && data.readingDate && moment(data.readingDate)
                    })(
                      <DatePicker showTime disabled={((title === 'EDIT' || title === 'VIEW') && filters['readingDate'] && filters['readingDate'].options.disabledOnEdit) || false} />
                    )}
                  </Form.Item>
                );
              }
              if (item !== 'lastIotReadingTime' && item !== 'lastIotReading' && item !== 'readingDateTs' && item !== 'calculatedReading') {
                return getFormFieldByType(filters, item, getFieldDecorator, data, { title });
              }
            }
          })}

          <Form.Item>
            <Button type='primary' className='gx-mb-0' htmlType='submit' loading={loading}>
              {title === 'EDIT' ? 'UPDATE' : 'CREATE'}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Spin>
  );
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  }
})(Create);

export default CreateForm;
